/** Lexo brend belgisi (v3 brendbuk): ikki kartochka + «L» + sariq nuqta, yonida «lexo» so'z belgisi. */
export function BrandMark() {
  return (
    <svg viewBox="0 0 100 100" width="100%" height="100%" aria-hidden="true">
      <rect x="34" y="10" width="52" height="68" rx="13" fill="#9EC2FF" transform="rotate(10 60 44)" />
      <rect x="16" y="20" width="54" height="70" rx="13" fill="#1A66F5" />
      <path d="M33 37V71H52" fill="none" stroke="#fff" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="56" cy="36" r="5.5" fill="#FFC629" />
    </svg>
  );
}

export function Brand({ className = 'brand' }: { className?: string }) {
  return <div className={className}><span className="mk"><BrandMark /></span><span className="wm">lexo</span></div>;
}
